import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { List } from "antd";
import { useDispatch, useSelector } from "react-redux";

import styles from "./GuestRsvpAddMeal.module.css";
import {
  DropDown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { MdDelete } from "react-icons/md";
import { setRSVP } from "../../../../Store/Actions/EventPlanningActions";
import { useNavigate } from "react-router-dom";

const initialState = {
  name: "",
  selectMeal: "",
};

const GuestRsvpAddMeal = () => {
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const [atendeeArr, setAtendeeArr] = useState(
    RSVP?.atendeeArr?.length > 0 ? RSVP?.atendeeArr : []
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [inputs, setInputs] = useState(initialState);
  const renderMealList = (item, index) => {
    return (
      <div className={styles.listItem} key={index}>
        <TextComponent text={item?.name} textClass={styles.listName} />
        <TextComponent
          text={item?.description}
          textClass={styles.listDesscription}
        />
      </div>
    );
  };

  const onAddAtendee = () => {
    if (!inputs.name || !inputs.selectMeal) {
      dispatch(
        showAlert({
          type: "error",
          message: "All fields are required",
        })
      );
    } else {
      setAtendeeArr([inputs, ...atendeeArr]);
      setInputs(initialState);
    }
  };

  // console.log("atendeeArr", atendeeArr);

  const onSave = () => {
    dispatch(setRSVP({ ...RSVP, atendeeArr }));
    navigate(-1);
  };
  return (
    <div className={styles.mainCont}>
      <List
        dataSource={RSVP?.meals?.length > 0 ? RSVP?.meals : []}
        className={styles.list}
        renderItem={renderMealList}
      />
      <TextComponent
        text={
          "Please provide the names and meal selection for your group invitation"
        }
        textClass={styles.mealHeading}
      />
      {atendeeArr?.map((item, index) => (
        <div className={styles.inputsDiv}>
          <InputField
            value={item.name}
            onChange={(e) => {
              atendeeArr[index].name = e.target.value;
              setAtendeeArr([...atendeeArr]);
            }}
            placeholder={"Name"}
          />
          <div className={styles.dropDownDiv}>
            <DropDown
              placeholder={"Select meal of your choice"}
              // onChange={handleChangeVendorType}
              object={RSVP?.meals}
              style={{ zIndex: index + 15 }}
              selectedValue={item.selectMeal.val}
              // selectedValue={item.}
              stylesClass={styles.dropDown}
              onChange={(e) => {
                atendeeArr[index].selectMeal = e;
                setAtendeeArr([...atendeeArr]);
              }}
              // options={RSVP?.meals}
            />
            <div
              className={styles.addBtn}
              onClick={() => {
                setAtendeeArr((prev) => {
                  let cpy = [...prev];
                  cpy.splice(index, 1);
                  return cpy;
                });
              }}
            >
              <MdDelete />
            </div>
          </div>
        </div>
      ))}
      <div className={styles.inputsDiv}>
        <InputField
          value={inputs?.name}
          onChange={(e) => setInputs({ ...inputs, name: e.target.value })}
          placeholder={"Name"}
        />
        <div className={styles.dropDownDiv}>
          <DropDown
            placeholder={"Select meal of your choice"}
            // onChange={handleChangeVendorType}
            object={RSVP?.meals}
            stylesClass={styles.dropDown}
            onChange={(e) => setInputs({ ...inputs, selectMeal: e })}
            selectedValue={inputs.selectMeal?.val}
            // options={RSVP?.meals}
          />
          <div className={styles.addBtn} onClick={onAddAtendee}>
            <FaPlus />
          </div>
        </div>
      </div>
      <div className={styles.btnDiv}>
        <SubmitButton title={"Save"} btnClass={styles.btn} onClick={onSave} />
      </div>
    </div>
  );
};

export default GuestRsvpAddMeal;
